import { LoadingIndicator } from './LoadingIndicator';

export { LoadingIndicator };

export default LoadingIndicator;
